import React, { useState, useEffect } from "react";
import { GoogleMap, Marker, LoadScript, InfoWindow } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "100%"   // ✅ sada se visina prilagođava roditelju
};

const GoogleMapComponent = ({ centar, markers }) => {

  const [mapInstance, setMapInstance] = useState(null);
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [isOn, setIsOn] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [dimming, setDimming] = useState(100); // dimming vrijednost od 0 do 100

  const getIconByType = (status) => {
    switch (status) {
      case "active":
        return "https://smartlight-frontend-smartlight.apps.okd-prod.smart-iot.bhtelecom.ba/assets/icons/lighton.png";
      case "inactive":
        return "https://smartlight-frontend-smartlight.apps.okd-prod.smart-iot.bhtelecom.ba/assets/icons/lightoff.png";
      case "alarm":
        return "https://smartlight-frontend-smartlight.apps.okd-prod.smart-iot.bhtelecom.ba/assets/icons/lightalarm.png";
      default:
        return "https://maps.google.com/mapfiles/ms/icons/yellow-dot.png";
    }
  };

  console.log(markers);

  console.log(centar);

  const sendCommand = async (devEUNumber, command) => {
    try {
      setDisabled(true);

      const payload = {
        devEUNumber,
        command,
      };

      console.log(payload);

      const response = await fetch("https://commandserver-smartlight.apps.okd-prod.smart-iot.bhtelecom.ba/api/smartlampcontrol", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error("Greška u HTTP zahtevu");
      }

      const data = await response.json();
      console.log("Odgovor sa servera:", data);

      if (command === "off") {
        setIsOn(false);
        setDimming(0)
      } else if (command === "on") {
        setIsOn(true);
        setDimming(100);
      } else {
        setIsOn(true);
      }

    } catch (error) {
      console.error("Greška pri slanju poruke:", error);
    } finally {
      setTimeout(() => {
        setDisabled(false);
      }, 10000);
    }
  };

  return (
    <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={centar}
        zoom={20}
        mapTypeId="satellite"
        onLoad={map => setMapInstance(map)}
      >
        {markers &&
          markers.map((m, i) => (
            <Marker
              key={i}
              position={{ lat: m.lat, lng: m.lng }}

              label={{
                text: String(i + 1),
                color: "white",
                fontSize: "14px",
                fontWeight: "bold",
              }}

              icon={
                mapInstance
                  ? {
                    url: getIconByType(m.status),
                    scaledSize: new window.google.maps.Size(40, 40)
                  }
                  : undefined
              }
              onClick={() => {console.log("Klik:", m); setSelectedMarker({ ...m, id: m.id ?? i })}}
            />
          ))}

        {selectedMarker && (
            <InfoWindow
              position={{ lat: selectedMarker.lat, lng: selectedMarker.lng }}
              onCloseClick={() => setSelectedMarker(null)}
            >
              <div
                style={{
                  backgroundColor: "#001536",
                  color: "#fff",
                  minWidth: "190px",
                  padding: "12px",
                  borderRadius: "10px",
                  textAlign: "center",
                  overflow: "hidden",
                  boxShadow: "0 6px 12px rgba(0,0,0,0.25)"
                }}
              >
                <h4 style={{ margin: "0 0 6px 0" }}>
                  Lampa: {selectedMarker.name}
                </h4>

                <p style={{ margin: "4px 0" }}>
                  <strong>Status:</strong> {selectedMarker.status}
                </p>

                <p style={{ margin: "4px 0 10px 0", fontSize: "12px", opacity: 0.85 }}>
                  {selectedMarker.devEUNumber}
                </p>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "10px"
                  }}
                >
                  <button
                    className="control-btn on"
                    style={{ backgroundColor: "#28a745" }}   // fallback
                    onClick={() => sendCommand(selectedMarker.devEUNumber, "on")}
                  >
                    ON
                  </button>

                  <button
                    className="control-btn off"
                    style={{ backgroundColor: "#dc3545" }}   // fallback
                    onClick={() => sendCommand(selectedMarker.devEUNumber, "off")}
                  >
                    OFF
                  </button>
                </div>
              </div>
            </InfoWindow>
        )}


      </GoogleMap>
    </LoadScript>
  );
};

export default GoogleMapComponent;
